import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { defineElement } from "@lordicon/element";
import { DevicesAllocatedContentSharedComponent } from "./devices-allocated-content-shared/devices-allocated-content-shared.component";
import { DropdownsModule } from "src/app/core/dropdowns/dropdowns.module";
import { FormsModalModule } from "src/app/forms-modal/forms-modal.module";
import { GridViewModule } from "src/app/core/grid-view/grid-view.module";
import lottie from 'lottie-web';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PageComponentsModule } from "src/app/core/page-components/page-components.module";
import { ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { StatTileModule } from "src/app/shared/stat-tile/stat-tile.module";
import { ToastsContainer } from "src/app/shared/toast/toasts-container.component";
import { WidgetModule } from "src/app/shared/widget/widget.module"

@NgModule({
  declarations: [
    DevicesAllocatedContentSharedComponent
    ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    DropdownsModule,
    FormsModalModule,
    GridViewModule,
    NgbModule,
    OverlayPanelModule,
    PageComponentsModule,
    ReactiveFormsModule,
    SharedModule,
    StatTileModule,
    ToastsContainer,
    WidgetModule
  ],
  exports: [
    DevicesAllocatedContentSharedComponent
  ],
  providers: [
  ]
})

export class ProvisioningModuleContentShared {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
